import {AbstractControl, FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';
import moment from 'moment';
import {isNil} from "lodash-es";

export function generateTimestampFromDateTimeAsString(d: string) {

  const sdt = moment(d, 'YYYY-MM-DD hh:mm A');


  return sdt.format('x');
}

export function isValidDate(dateObject){
  return new Date(dateObject).toString() !== 'Invalid Date';
}

export function getDateAsStringFromDateObject(d: Date): string {

  if (!isValidDate(d)) {
    console.log(d);
    return null;
  }
  const xdate = d.toJSON().substring(0,10);
  const xtime = d.toTimeString().substring(0,8);
  return xdate + ' ' + xtime;
}

// custom validator to check that starDate is before endDate
export function DatesInOrder( startDate: string, endDate: string, errorKey='datesInOrder') {
    return (formGroup: FormGroup) => {
        const startDateControl = formGroup.controls[startDate];
        const endDateControl = formGroup.controls[endDate];

        if (endDateControl.errors && !endDateControl.errors.mustMatch) {
            // return if another validator has already found an error on the endDateControl
            return;
        }

        if (isNil(startDateControl.value) || isNil(endDateControl.value) || startDateControl.value === '' || endDateControl.value === '') {
          //no two dates
          return;
        }

        // set error on endDateControl if validation fails
        if (startDateControl.value > endDateControl.value) {
          const response = {};
          response[errorKey] = true;
          endDateControl.setErrors(response);

          // displays error if the end date has the invalid default value
          endDateControl.markAsTouched();

          return response;
        } else {
          endDateControl.setErrors(null);
          return null;
        }
    };
}

export function DatesInSameMonth(startDate: string, endDate: string) {
  return (formGroup: FormGroup) => {
    const startDateControl = formGroup.controls[startDate];
    const endDateControl = formGroup.controls[endDate];

    if (endDateControl.errors && !endDateControl.errors.mustMatch) {
      // return if another validator has already found an error on the endDateControl
      return;
    }

    if ((!isNil(startDateControl.value) && startDateControl.value !== '' && !isNil(endDateControl.value) && endDateControl.value !== '')) {
      if (moment(startDateControl.value).month() != moment(endDateControl.value).month()) {
        endDateControl.setErrors({datesInSameMonth: true});
      } else {
        endDateControl.setErrors(null)
      }
    }
  };
}

export function NotInBlackoutDays(startDate: string): ValidatorFn {

  return (control: AbstractControl): ValidationErrors | null => {
    const startDateControl = control.get(startDate);
    const thedate = moment(startDateControl.value);
    const blackoutDayIds = control.get('blackoutDays').value;
    const isoWeekDaysToMIDays = {
      1: 2, 2: 3, 3: 4, 4: 5, 5: 6, 6: 7, 7: 1
    };
    // MI blackout days: Sunday = 1; Saturday = 7
    if (blackoutDayIds === null || (blackoutDayIds.length === 1 && isNaN(blackoutDayIds[0]))) {
      return null;
    }

    if ((startDateControl.value !== null && startDateControl.value !== '') &&
      blackoutDayIds.includes(isoWeekDaysToMIDays[thedate.isoWeekday()])) {
        startDateControl.setErrors({ notInBlackoutDays: true });
      return { notInBlackoutDays: true };
    } else {
      startDateControl.setErrors(null);
      return null;
    }

  }
}

export function NotInThePast( startDate: string): ValidatorFn  {
  return (control: AbstractControl): ValidationErrors | null => {
      const startDateControl = control.get(startDate);
      if ((startDateControl.value !== null && startDateControl.value !== '') &&
      (moment(startDateControl.value).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD'))) {
        return { notInThePast: true };
      } else {
        return null;
      }
  };
}

export function NotOlderThanOneMonth( startDate: string) {
  return (formGroup: FormGroup) => {
      const startDateControl = formGroup.controls[startDate];
      if ((startDateControl.value !== null && startDateControl.value !== '') &&
      (moment(startDateControl.value).format('YYYY-MM-DD') < moment().subtract(1, 'month').format('YYYY-MM-DD'))) {
        startDateControl.setErrors({ notOlderThanOneMonth: true });
      } else {
        startDateControl.setErrors(null);
      }
  };
}


export function DateTimesInOrder(startDateTime: string, endDateTime: string, errorKey='dateTimesInOrder'): ValidatorFn {

  return (control: AbstractControl): ValidationErrors | null => {

    const startDateTimeControl = control.get(startDateTime);
    const endDateTimeControl = control.get(endDateTime);

    if (
      startDateTimeControl.value  &&
      endDateTimeControl.value
    ) {

      const startDateTime = generateTimestampFromDateTimeAsString(getDateAsStringFromDateObject(startDateTimeControl.value));
      const endDateTime = generateTimestampFromDateTimeAsString(getDateAsStringFromDateObject(endDateTimeControl.value));

      if ( startDateTime > endDateTime) {
        const response = {};
        response[errorKey] = true;
        endDateTimeControl.setErrors(response);
        return response;
      } else {
        endDateTimeControl.setErrors(null);
        return null;
      }
    }
    return null;
  }
}

